import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  unreadCount: 0,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      state.items = [action.payload, ...state.items];
      state.unreadCount += 1;
    },
    markAllAsRead: (state) => {
      state.items = state.items.map((notification) => ({
        ...notification,
        read: true,
      }));
      state.unreadCount = 0;
    },
    markAsRead: (state, action) => {
      const notification = state.items.find((item) => item.id === action.payload);
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount -= 1;
      }
    },
    clearNotifications: (state) => {
      state.items = [];
      state.unreadCount = 0;
    },
  },
});

export const { addNotification, markAllAsRead, markAsRead, clearNotifications } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
